import { createStore, applyMiddleware, Store } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import { getStoreType } from "../storage/functions";
import { getEnvVariable, REACT_APP_STORE } from "utils/environment";
import { saveLocalState } from "../storage/local-storage";
import { saveSessionState } from "../storage/session-storage";

import { combineReducers, Reducer } from "redux";

/* Reducers */
import AppReducer from "./reducers/global/reducer";
import KeycloakReducer from "./reducers/keycloak/reducer";
import PreferencesReducer from "./reducers/preferences/reducer";

/* End reducers */

/**
 * Creates the main reducer with the dynamically injected ones
 */
const rootReducer = (injectedReducers = {}): Reducer<any, never> => {
  return combineReducers({
    app: AppReducer,
    preferences: PreferencesReducer,
    keycloak: KeycloakReducer,
    ...injectedReducers,
  });
};

const typeStore: string = getEnvVariable(REACT_APP_STORE)?.toLowerCase();
const initialState = !typeStore ? {} : getStoreType(typeStore);

const middlewares = [thunk];

const enhancers = [applyMiddleware(...middlewares)];

const store: Store<any, never> & {
  dispatch: unknown;
} = createStore(rootReducer(), initialState, composeWithDevTools(...enhancers));

if (Object.keys(initialState).length === 0) {
  if (typeStore === "session") {
    saveSessionState(store.getState());
    store.subscribe(() => {
      saveSessionState(store.getState());
    });
  } else if (typeStore === "local") {
    saveLocalState(store.getState());
    store.subscribe(() => {
      saveLocalState(store.getState());
    });
  }
}

export default store;
